import { render } from "./PwaManifestCopyPopup.vue?vue&type=template&id=2ad1c474"
import script from "./PwaManifestCopyPopup.vue?vue&type=script&lang=js"
export * from "./PwaManifestCopyPopup.vue?vue&type=script&lang=js"

import "./PwaManifestCopyPopup.vue?vue&type=style&index=0&id=2ad1c474&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__